<template lang="pug">
div

    b-modal(v-model='showSendOwnerSettlementModal' has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
        template(#default='props')
            SendOwnerSettlementModal(:data="formData", :owner="owner"
                @close='props.close'
                @refreshInbox="refreshInbox()")
    p todo
    //- .button-wrapper
    //-     b-dropdown(hoverable='' aria-role='list')
    //-         button.button.is-light(slot='trigger')
    //-             span Neue Abrechnung erstellen
    //-             b-icon(icon='menu-down')
    //-         b-dropdown-item(v-for="d in possibleSettlements" :key="`${d.year}-${d.month}`" aria-role='listitem' @click="createSettlement(d)")
    //-             .media
    //-                 .media-content
    //-                     h3 {{d.year}} {{monthNames[d.month]}}
    //- .levels
    //-     p.heading Gesamte Povision
    //-         p.title 3,456
    //- .card.margin-top(v-if="id")
    //-     .main.margin-top
    //-         b-table(:data="settlements"
    //-             default-sort-direction="asc"
    //-             default-sort="date"
    //-             hoverable)
    //-             b-table-column(field='year' label='Jahr' sortable, v-slot="props")
    //-                 | {{props.row.year}}
    //-             b-table-column(field='month' label='Monat' sortable, v-slot="props")
    //-                 | {{monthNames[props.row.month]}}
    //-             b-table-column(field='bookingCount' label='Buchungen' sortable, v-slot="props")
    //-                 | {{props.row.bookingCount}}
    //-             b-table-column(field='commissionTotal' label='Gesamtprovision' sortable, v-slot="props")
    //-                 | {{props.row.total}}
    //-             b-table-column(label='Aktionen', v-slot="props")
    //-                 .button-wrapper
    //-                     b-button(type="is-primary" @click="$router.push(`invoice/${props.row.year}/${props.row.month}`)" ) Öffnen
</template>

<script>
import SendOwnerSettlementModal from '@/components/molecules/SendOwnerSettlementModal.vue';

export default {
    components: {
        SendOwnerSettlementModal
    },
    props: {
        id: {
            type: [Number, String],
            default: null
        },
        owner: {
            type: Object
        },
        createdAt: {
            type: Date,
            default: new Date
        }
    },
    data() {
        return {
            showSendOwnerSettlementModal: false,
            formData: {
                month: null,
                year: null
            },
            monthNames: [
                "Januar",
                "Februar",
                "März",
                "April",
                "Mai",
                "Juni",
                "Juli",
                "August",
                "September",
                "Oktober",
                "November",
                "Dezember"
            ]
        };
    },
    computed: {
        possibleSettlements() {
            const dates = [];

            // const todayMonth = new Date().getMonth();
            const todayYear = new Date().getFullYear();

            // const pastMonth = this.createdAt.getMonth();
            const pastYear = this.createdAt.getFullYear();

            // const diffMonth = todayMonth - pastMonth;
            const diffYear = todayYear - pastYear;

            for (let y = 0; y < diffYear + 1; y += 1) {
                for (let m = 0; m < 12; m += 1) {
                    dates.push({ month: m, year: todayYear + y })
                }
            }

            return dates.reverse();
        }
    },
    async mounted() {
        const loadingComponent = this.$buefy.loading.open();
        // this.data = await this.$store.dispatch("owners/findAllSettlements", { id: this.id });
        // this.data.commissions.sort(function(a,b){
        //   return new Date(b.date) - new Date(a.date);
        // });
        loadingComponent.close();
    },
    methods: {
        createSettlement(d) {
            this.formData.year = d.year;
            this.formData.month = d.month;
            this.showSendOwnerSettlementModal = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.two-column {
    display: flex;
    justify-content: space-between;
}
</style>